import React from "react";

function TestPage() {
  return (
    <>
      <h1>Test Page</h1>
      <p>
        This is a test page for verifying the functionality of the web application.
      </p>
      /*i want this button to go to an url */
      <button onClick={() => window.location.href = "https://o21p.com/"}>
        Go to main page
      </button>
    </>
  );
}

export default TestPage;